import React from 'react';
import clsx from 'clsx';
import { TagReact } from 'common/components/tag';
import { TagSize, TagTheme } from 'common/components/tag/types';
import styles from './_setting.module.styl';
type ExperimentPageConfigurationSettingProps = {
  label: string;
  value: string;
  disabled?: boolean;
};
export function ExperimentPageConfigurationSetting(props: ExperimentPageConfigurationSettingProps) {
  return <div className={clsx(styles.setting, {
    [styles.disabled]: props.disabled
  })} data-sentry-component="ExperimentPageConfigurationSetting" data-sentry-source-file="_setting.tsx">
      <div className={styles.label}>{props.label}</div>
      <TagReact className={styles.tag} theme={TagTheme.Secondary} truncate tagName={props.value} size={TagSize.Small} data-sentry-element="TagReact" data-sentry-source-file="_setting.tsx" />
    </div>;
}